import { FeatureFlagName } from '@/common/types/featureFlag'
import { featureFlags } from '@/common/helpers/configResolver'
import { ADMIN_ROUTE_PATHS } from '@/admin/types/router'

export const isFeatureEnabled = function (feature: FeatureFlagName) {
  return featureFlags.includes(feature)
}

// map of featureFlag and its related views (list of view link)
export const featureFlagViews: { [key in FeatureFlagName]?: string[] } = {
  [FeatureFlagName.AI_AGENT_PRODUCTIVITY]: [ADMIN_ROUTE_PATHS.ADMIN_AI_SUMMARIZE, ADMIN_ROUTE_PATHS.AUTOMATIC_RESOLUTION_NOTES],
  [FeatureFlagName.EXTERNAL_REFERENTIAL_CUSTOMER_MS]: [ADMIN_ROUTE_PATHS.EXTERNAL_REFERENTIAL_CUSTOMER_MS],
  [FeatureFlagName.NEW_MAIL_MANAGMENT]: [ADMIN_ROUTE_PATHS.MAIL_STORAGE_SETTINGS],
}

// check if item/view should be disabled if related to a featureFlag
export const isDisabledFeatureView = (viewLink: string | undefined): boolean => {
  for (const [flagName, featureItems] of Object.entries(featureFlagViews)) {
    if (featureItems?.includes(viewLink ?? '') && !isFeatureEnabled(flagName as FeatureFlagName)) {
      return true
    }
  }
  return false
}
